import { CmsObjectWithDefault } from '@components/Cms/types';

// Todo: Fix naming convention of each key, either follow camelCase or PascalCase
export type EmailSignupFormViewCmsKey =
    | 'emailLabel'
    | 'passwordLabel'
    | 'firstNameLabel'
    | 'lastNameLabel'
    | 'confirmPasswordLabel'
    | 'btnSignUp'
    | 'yourPolicy'
    | 'pleaseAccept'
    | 'checkAll'
    | 'checkTermsOfService'
    | 'required'
    | 'checkPrivacyPolicy'
    | 'checkThirdPartyPrivacy'
    | 'link'
    | 'sendMeOffers'
    | 'affiliateAgreement'
    | 'partnerCenterAgreeToTerms'
    | 'partnerCenterEmailSubscribe';
export const EmailSignupFormViewCmsWithDefault: CmsObjectWithDefault<EmailSignupFormViewCmsKey> = {
    firstNameLabel: {
        cmsId: 68344,
        defaultTranslation: 'First name',
    },
    lastNameLabel: {
        cmsId: 68345,
        defaultTranslation: 'Last name',
    },
    emailLabel: {
        cmsId: 76295,
        defaultTranslation: 'Email',
    },
    passwordLabel: {
        cmsId: 76296,
        defaultTranslation: 'Password',
    },
    confirmPasswordLabel: {
        cmsId: 4149,
        defaultTranslation: 'Confirm Password',
    },
    btnSignUp: {
        cmsId: 76298,
        defaultTranslation: 'Sign up',
    },
    yourPolicy: {
        cmsId: 139901,
        defaultTranslation: 'Your data privacy policy',
    },
    pleaseAccept: {
        cmsId: 139902,
        defaultTranslation: 'Please accept all privacy policy consent to process the booking',
    },
    checkAll: {
        cmsId: 139968,
        defaultTranslation: 'I consent to all of below privacy policy',
    },
    checkTermsOfService: {
        cmsId: 139903,
        defaultTranslation: 'I agree to the Terms of Service, and I confirm that I am 18 years or older',
    },
    required: {
        cmsId: 139904,
        defaultTranslation: '[Required]',
    },
    checkPrivacyPolicy: {
        cmsId: 139905,
        defaultTranslation:
            'I consent to the collection and use of my personal information in accordance with the Privacy Policy',
    },
    checkThirdPartyPrivacy: {
        cmsId: 139906,
        defaultTranslation:
            'I consent to the third-party provision, either in Korea or overseas, of my personal information in accordance with the Privacy Policy',
    },
    link: {
        cmsId: 139907,
        defaultTranslation: '(Link)',
    },
    sendMeOffers: {
        cmsId: 76299,
        defaultTranslation: 'Send me special offers & Promotions',
    },
    affiliateAgreement: {
        cmsId: 66292,
        defaultTranslation: 'Affiliate Agreement',
    },
    partnerCenterAgreeToTerms: {
        cmsId: 76270,
        defaultTranslation: 'I agree to the terms and conditions in the {0}',
    },
    partnerCenterEmailSubscribe: {
        cmsId: 85158,
        defaultTranslation:
            'I would like to receive updates and learn about new features and products by email. I understand I may unsubscribe at any time.',
    },
};
